<div class="mt-8 pb-10 flex">
  <div class="i-tekom-logo w-18 h-6"></div>
  <div class="ml-2 tk-c-gray">{{'handover.footer' | translate}} {{model?.createDate | date:'medium'}}</div>
</div>
